import { render, staticRenderFns } from "./OverviewSection.vue?vue&type=template&id=71935193&scoped=true&"
import script from "./OverviewSection.vue?vue&type=script&lang=js&"
export * from "./OverviewSection.vue?vue&type=script&lang=js&"
import style0 from "./OverviewSection.vue?vue&type=style&index=0&id=71935193&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71935193",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VDivider,VFlex,VHover,VIcon,VImg,VLayout,VTooltip})
